/**
 * src/shell/ui/components/EventFeed.tsx — 事件流播报（设计稿 §5.1.2 渲染分工）。
 *
 * 分工（守门员复核对齐）：
 * - narration 事件：引擎携带的人格口吻文本，直接渲染；
 * - phase/audit/warn/error/gate/wakeup/stream-snapshot 系统类事件：
 *   外壳按模板渲染（模板文案占位·待编剧，见 copy.ts eventTpl）。
 */

import type { RunEvent } from '../../../gm'
import { COPY } from '../../copy'

function renderEvent(e: RunEvent): { cls: string; text: string } {
  const T = COPY.eventTpl
  const p = e.payload
  switch (e.kind) {
    case 'narration':
      return { cls: 'evt-narration', text: `${String(p.speaker)}：${String(p.text)}` }
    case 'phase':
      if (p.phase === 'idle') return { cls: 'evt-dim', text: '' }
      return { cls: 'evt-phase', text: T.phase(String(p.detail ?? p.phase)) }
    case 'audit':
      return { cls: 'evt-dim', text: T.audit(String(p.key), String(p.fields)) }
    case 'warn':
      return { cls: 'evt-warn', text: T.warn(String(p.text)) }
    case 'error':
      return { cls: 'evt-error', text: T.error(String(p.text)) }
    case 'gate':
      return { cls: 'evt-gate', text: p.direction === 'exit' ? T.gateExit : T.gateEnter }
    case 'wakeup':
      return { cls: 'evt-dim', text: T.wakeup(String(p.action), String(p.transition)) }
    case 'stream-snapshot':
      return { cls: 'evt-dim', text: T.stream(String(p.stage), Number(p.received)) }
  }
}

export function EventFeed({ events, limit = 50 }: { events: RunEvent[]; limit?: number }) {
  const shown = events.slice(-limit)
  return (
    <div className="event-feed">
      {shown.map((e) => {
        const { cls, text } = renderEvent(e)
        if (!text) return null
        return (
          <div key={`${e.projectId ?? '_g'}:${e.seq}`} className={`event-line ${cls}`}>
            {text}
          </div>
        )
      })}
    </div>
  )
}
